import { takeLatest, all, fork, put, call } from 'redux-saga/effects';
import Actions from 'actions';
import { setCacheExp } from 'utils/dataCache';
import api from 'api';

function* createConsultationService({ params, callbacks = {} }) {
  try {
    const { data } = yield call(api.createConsultationService, params);
    const cacheExp = setCacheExp(10);
    yield put(Actions.createConsultationServiceSuccess({ data, cacheExp }));
    if (typeof callbacks.success === 'function') {
      yield call(callbacks.success);
    }
  } catch (error) {
    yield put(Actions.createConsultationServiceFail(error));
    if (typeof callbacks.fail === 'function') {
      const err = error?.response?.data?.error;
      const msg = Array.isArray(err)
        ? err.join(', ')
        : err || 'Failed to add info';
      yield call(callbacks.fail, msg);
    }
  }
}

function* watchCreateConsultationService() {
  yield takeLatest(
    Actions.CREATE_CONSULTATION_SERVICE_REQUEST,
    createConsultationService
  );
}

export default function* create() {
  yield all([fork(watchCreateConsultationService)]);
}
